import React from 'react'

const PastFetes = ({ count }: { count: number }) => {
    return (
        <>
		<div className="flex gap-x-6">
		{count > 0 &&
            Array.from({ length: count }).map((item: any, index: number) => (
				<div key= { index } className ="">
				<div className="w-[280px] h-[375px] rounded overflow-hidden shadow-lg animate-pulse">
					<div className="w-full h-56 bg-gray-200"></div>
					<div className ="px-6 py-4">
						<div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
						<div className = "h-4 bg-gray-200 rounded w-full mb-2"> </div>
						<div className = "h-4 bg-gray-200 rounded w-2/3"> </div>
					</div>
					<div className ="px-6 py-4">
						<div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
						<div className = "h-4 bg-gray-200 rounded w-full mb-2"> </div>
						<div className = "h-4 bg-gray-200 rounded w-2/3"> </div>
					</div>
					<div className= "px-6 pt-4 pb-2 mb-2">
						<div className="inline-block bg-gray-200 rounded-full h-4 w-24 mr-2"></div>
						<div className="inline-block bg-gray-200 rounded-full h-4 w-16 mr-2"></div>
						<div className="inline-block bg-gray-200 rounded-full h-4 w-16 mr-2"></div>
					</div>
				</div>
			</div>
            ))}
		</div>
          
        </>
      );
}

export default PastFetes